export default {
    FALTA_EM_ESTOQUE: 1,
    FALTA_NO_ENVIO_ESTADUAL: 2,
    NAO_ENTREGUE: 3,
    VENCIDO: 4,
    OUTRO: 5,
}
